
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InnerLoading',
  components: {},
  props: {
    showing: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
});
